import React from 'react';

const TrendResearchLayout = ({ children }) => {
	return (
		<div className="top-header">
			<div className="trend-list">{children}</div>
		</div>
	);
};

export default TrendResearchLayout;
